import axios from "axios";
import { Dialog, Toast } from "antd-mobile";
import Cookies from "js-cookie";
import { _cookie, _route } from "./constant";
import {
  isApp,
  isCurrentVersionHigher,
  resetAllCookies,
  resetApp,
  getAppVersion,
  isIos,
  isAndroid,
  isHarmony,
  isSdicHomeApp,
} from "./utils";
import host, { app_api, community_host } from "./host";
import sdicHomeEmit from "./prototal";
import { API_RESULT_CODE, ResponseProps } from "@/config/types/common";
import { maintenance_url } from "@/utils/host.sit";

const getToken = async () => {
  return new Promise((resolve) => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("access_token")) {
      resolve(searchParams.get("access_token"));
    } else {
      if (isApp()) {
        // 先获取app版本号，>=1.0.500才从app拿token，老版本还是走cookie里面的token
        if (isCurrentVersionHigher(getAppVersion(), "1.0.500")) {
          sdicHomeEmit("getToken873265239", {
            onCallback(data: string) {
              resolve(JSON.parse(data)?.token || Cookies.get(_cookie.TOKEN) || "");
            },
          });
        } else {
          resolve(Cookies.get(_cookie.TOKEN) || "");
        }
      } else {
        // 不是app直接拿cookie里面的
        resolve(Cookies.get(_cookie.TOKEN) || "111");
      }
    }
  });
};

const createAxiosInstance = (baseURL: string) => {
  const service = axios.create({
    baseURL: baseURL, // url = base url + request url
    timeout: 60_000, // request timeout
  });
  service.interceptors.request.use(
    async (config) => {
      config.headers = config.headers || {};
      if (baseURL !== app_api) {
        let source = "Web";
        if (isApp()) {
          source = "App";
        }
        if (isIos()) {
          source += "|IOS";
        } else if (isAndroid()) {
          source += "|Android";
        } else if (isHarmony()) {
          source += "|HarmonyOS";
        }
        config.headers["X-Source"] = source;
      }

      const token: any = await getToken();
      if (!token) {
        resetApp();
      } else {
        if (token) {
          config.headers["X-AccessToken"] = token;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  service.interceptors.response.use(
    async (response) => {
      interceptorRequest();
      const res = response.data;
      const code = res && res.code;
      const msg = res && res.msg;
      const token: any = await getToken();
      if (code === -1 && !token) {
        Toast.show({
          icon: "fail",
          content: msg,
        });
        return Promise.reject(null);
      }
      if (code === 250008 || code === 250004 || code === 401 || code === -1002) {
        //当前会话已过期，请重新登录
        resetAllCookies();
        if (isApp()) {
          // sdicHomeEmit("logout");
          Dialog.alert({
            content: "token过期，请关闭该页面，前往首页刷新页面",
            afterClose: () => {
              sdicHomeEmit("closeWebview");
            },
          });
        } else {
          let url = "";
          url = `${process.env.PUBLIC_URL}${_route.LOGIN}?redirect=${encodeURIComponent(
            window.location.href
          )}`;
          Toast.show({
            icon: "fail",
            content: "当前会话已过期，请重新登录",
            duration: 2000,
            afterClose: () => {
              window.location.href = url;
            },
          });
        }
        return Promise.reject(null);
      } else if (code === API_RESULT_CODE.SERVICE_UPDATING) {
        window.location.replace((res.data as any).url);
        return Promise.reject(null);
      }
      return Promise.resolve(res);
    },
    (error) => {
      const { response } = error;
      if (response) {
        // 请求已发出，但是不在2xx的范围
        errorHandle(response);
      } else {
        // 处理断网的情况
        // eg:请求超时或断网时，更新state的network状态
        // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
        // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
        Toast.show({ icon: "fail", content: "网络连接异常,请稍后再试!" });
      }
      if (response && response.data) {
        return Promise.reject(response.data);
      }
      return Promise.reject(null);
    }
  );
  function errorHandle(res: any) {
    // 状态码判断
    switch (res.status) {
      case 401:
        Toast.show({ icon: "fail", content: "请求未授权" });
        break;
      case 403:
        Toast.show({ icon: "fail", content: "服务器拒绝访问" });
        break;
      case 404:
        Toast.show({ icon: "fail", content: "请求的资源不存在" });
        break;
      default:
        Toast.show({ icon: "fail", content: "连接错误" });
    }
  }
  return service;
};

function interceptorRequest() {
  axios
    .request({
      url: maintenance_url,
      method: "get",
    })
    .then((resp) => {
      const { data: { openDialog = false } = {} } = resp || {};
      if (openDialog && isSdicHomeApp()) {
        sdicHomeEmit("openPage", {
          click_type: "APP",
          click_url: `wealhome://operationAlarm?json=${encodeURIComponent(
            JSON.stringify(resp?.data)
          )}`,
        });
        return Promise.reject(resp);
      }
      return Promise.resolve();
    })
    .catch((err) => {
      console.log(err);
    });
}

export async function preHandleResponse<T>(response: ResponseProps<T>): Promise<T> {
  if (response.code !== API_RESULT_CODE.SUCCESS) {
    if (response.code === API_RESULT_CODE.SERVICE_UPDATING) {
      window.location.replace((response.data as any).url);
      return Promise.reject(response as any);
    }
    return Promise.reject(response as any);
  }
  return Promise.resolve(response.data);
}

const request = createAxiosInstance(process.env.REACT_APP_BASE_API || host);
export const requestApp = createAxiosInstance(app_api);
export const requestCommunity = createAxiosInstance(community_host);

export default request;
